// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2139":"e6c6586a","4722":"70e61e63","6772":"d6ea41cb","7193":"3689f558","8010":"70e61e63"}[chunkId] + ".chunk.css";
};